import {FC} from 'react';
import {useTranslation} from 'react-i18next';

import Plus from '@/assets/images/icon-plus.svg?react';
import BorderedTextSeparator from '@/components/bordered-text-separator';
import {useDocumentCreationActions} from '@/components/new-document-creation/dialog/context/document-create-actions.hook';
import {ListItem} from '@/components/new-document-creation/list-item';
import {WEB_CLICK_TRACKING_KEY} from '@/services/analytics/web-click-tracking-key';

export const CreateForNewContractHolderStep: FC = () => {
  const {t} = useTranslation();
  const {onCreateForNewContractHolder} = useDocumentCreationActions();

  return (
    <>
      <BorderedTextSeparator>
        {t(
          'components.new-document-creation.dialog.content.step-create-for-new-contract-holder.section-separator-label',
        )}
      </BorderedTextSeparator>
      <h3 className="font-bold" data-testid="create-new-contract-holder-title">
        {t('components.new-document-creation.dialog.content.step-create-for-new-contract-holder.section-title')}
      </h3>
      <div className="flex w-full flex-col items-center gap-2">
        <ListItem
          data-testid="new-contract-holder-button"
          onClick={onCreateForNewContractHolder}
          trackingKey={WEB_CLICK_TRACKING_KEY.CREATE_NEW_ACCOUNT}
        >
          <Plus className="size-4 fill-violet" />
          {t('components.new-document-creation.dialog.content.step-create-for-new-contract-holder.create-button.label')}
        </ListItem>
      </div>
    </>
  );
};
